"use strict";
// The configuration options passed when creating the Wasm terminal
Object.defineProperty(exports, "__esModule", { value: true });
var WasmTerminalConfig = /** @class */ (function () {
    function WasmTerminalConfig(_a) {
        var fetchCommand = _a.fetchCommand, processWorkerUrl = _a.processWorkerUrl;
        this.fetchCommand = fetchCommand;
        this.processWorkerUrl = processWorkerUrl;
    }
    return WasmTerminalConfig;
}());
exports.default = WasmTerminalConfig;
